import { makeStyles, Theme } from '@material-ui/core/styles';


const useStyles = makeStyles((theme: Theme) => ({
  root: {
    color: 'white',
    width: '100%',
  },
  toolbar: {
    borderBottom: `1px solid ${theme.palette.primary.main}`,
    padding: 0,
    fontWeight: 700,
  },
  iconButton: {
    marginRight: '2rem',
  },
  imageButton: {
    backgroundColor: 'white',
    borderRadius: '0',
    '& p': {
      color: '#D93E46',
      textAlign: 'center',
      margin: '0.1rem',
    },
    '&:hover p': {
      color: '#FFF',
    },
  },
  text: {
    fontWeight: theme.typography.fontWeightBold,
    marginLeft: '30px',
  },
}));
export default useStyles;
